import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RuntimeConfigService } from '@core/services';
import { RuntimeConfig } from '../../../environments/environments.d';

export const runtimeConfigResolver: ResolveFn<RuntimeConfig> = () =>
  inject(RuntimeConfigService).loadRuntimeConfig();
